import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ZoneRead } from '../../entities/zone.dto';

@Injectable()
export class ZoneStore extends AbstractEntityStore<ZoneRead> {
    constructor() {
        super(PFWmsEntities.Zone);
    }
}
